<template>
  <footer>
    <div class="block cmi-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img
              class="img-responsive cmi-footer-logo"
              src="/dist/assets/logos/cmi_church_logo_main_txt_03.png"
              alt="RUPC CHURCH LOGO AND TEXT"
            />
          </div>
          <div id="contact" class="col-md-4">
            <h3 class="cmi-contact-h">LEICESTER CONTACTS</h3>
            <div class="widget">
              <div class="about">
                <div class="contact">
                  <ul>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-phone"></i>Mobile : </span
                      >077 2336 3184
                    </li>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-envelope"></i>E-mail : </span
                      >Leicester@rightwayupc.ca
                    </li>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-home"></i>Address : </span
                      ><br />
                      CMI Leicester<br />
                      87 Clarendon Street<br />
                      LE2 7FH, Leicester<br />
                      United Kingdom
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="cmi-quick-links">
              <account></account>
            </div>
            <div class="widget">
              <div class="about">
                <ul class="social-media">
                  <li>
                    <a href="javascript:void(0);" title=""
                      ><i class="fa fa-facebook"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" title=""
                      ><i class="fa fa-twitter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  components: {
    Account: () => import("./UserAccount")
  },
  data() {
    return {};
  }
};
</script>
